import {
  AppBar, UserMenu, Logout, useSidebarState,
  SidebarToggleButton, TitlePortal,
} from 'react-admin';
import { Box, MenuItem, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../styles/ds';

const CustomUserMenu = () => {
  const navigate = useNavigate();
  return (
    <UserMenu>
      <MenuItem onClick={() => navigate('/change-password')}>
        <ListItemIcon><LockResetIcon fontSize="small" /></ListItemIcon>
        <ListItemText>שינוי סיסמא</ListItemText>
      </MenuItem>
      <Logout />
    </UserMenu>
  );
};

const SidebarAutoClose = () => {
  const isMobile = useMediaQuery(`(max-width:${MOBILE_BREAKPOINT}px)`);
  const [open, setOpen] = useSidebarState();
  useEffect(() => {
    if (isMobile && open) setOpen(false);
  }, [isMobile]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

const CustomAppBar = (props) => (
  <>
    <SidebarAutoClose />
    <AppBar
      {...props}
      className="crm-appbar"
      userMenu={false}
      sx={{
        // react-admin's <AppBar> always auto-inserts its own sidebar-toggle
        // button before any children — hide that one; the explicit
        // <SidebarToggleButton /> below (no auto class) is the one we keep.
        '& .RaAppBar-menuButton': { display: 'none' },
        '& .MuiToolbar-root': { position: 'relative' },
      }}
    >
      {/* Keep the desktop title centered; mobile uses the flow layout in global.css. */}
      <Box className="crm-appbar-title" sx={{ flex: 1, textAlign: 'center', px: '100px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
        <TitlePortal />
      </Box>

      {/* Preserve desktop positioning. Mobile controls share the title's flex row. */}
      <Box className="crm-appbar-controls" sx={{
        position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
        display: 'flex', alignItems: 'center', gap: 0.5,
      }}>
        <SidebarToggleButton />
        <CustomUserMenu />
      </Box>
    </AppBar>
  </>
);

export default CustomAppBar;
